import { useAuthStore } from '@/stores/auth';
import { flushHeartbeat } from './visitTracker';

const HEARTBEAT_INTERVAL = 10 * 60 * 1000;  // 10 分钟
const FIRST_DELAY        =  3 * 60 * 1000;  // 第 3 分钟首次
const MAX_COUNT          = 6;                // 3 + 50 分钟后自动停

let timer: ReturnType<typeof setTimeout> | null = null;
let count = 0;

async function tick() {
  const auth = useAuthStore();
  if (!auth.loggedIn) return;
  count++;
  try {
    // 携带本地累计的 firstAt/path/regionCodes 一起发给后端，
    // 后端只 UPSERT 同一行，不再为切 region 单独发接口
    await flushHeartbeat();
  } catch { /* 静默重试由后端下一次心跳兜底 */ }
  if (count >= MAX_COUNT) { stopHeartbeat(); return; }
  timer = setTimeout(tick, HEARTBEAT_INTERVAL);
}

export function startHeartbeat() {
  if (timer) return;
  count = 0;
  timer = setTimeout(tick, FIRST_DELAY);
}

export function stopHeartbeat() {
  if (timer) { clearTimeout(timer); timer = null; }
  count = 0;
}
